export default __webpack_public_path__ + "static/media/positiondown.366615b7.svg";